import React from "react";
import Header from "../components/Header";
import Footer from "../components/Footer";
import { useEffect, useState } from "react";
import InteraktScript from "../../common/InteraktScript";
function About() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  const [userid, setUserid] = useState();
  useEffect(() => {
    const userIdValue = localStorage.getItem("userId");
    setUserid(userIdValue);
  }, [userid]);
  return (
    <div className="new-home">
      <Header userid={userid} />
      <div className=" margin-top">
        <section
          className="about-hero-section"
          style={{
            backgroundImage: `linear-gradient(180deg, rgba(255, 248, 243, 0.03) 0%, rgba(255, 255, 255, 0.82) 85%), url(${process.env.PUBLIC_URL}/aboutB.png)`,
          }}
        >
          <div className="about-hero-fog" />
          <div className="about-hero-fade" />
          <div className="about-hero-inner container">
            <div className="about-hero-copy">
              <h1 className="about-hero-heading">
                The Story Behind <span>Myprega</span>: Because
                <br />
                You Deserve More Than 15 Minutes a Month.
              </h1>
              <p className="about-hero-text">
                For decades, the traditional system has treated pregnancy as just
                another medical condition to be processed, rather than a profound life transformation to be
                celebrated. We watched incredibly capable women—who manage careers, homes, and lives
                with absolute precision—suddenly feel anxious, rushed, and alone the moment they stepped
                into a crowded clinic waiting room. They were handed scattered prescriptions, given rushed
                15-minute consultations once a month, and left to navigate their daily fears and midnight doubts
                completely on their own with zero daily health tracking to avoid and prevent complications early.
                We knew this wasn’t just unfair; it was a fundamental failure in maternal care.
              </p>
            </div>
          </div>
        </section>

        <section className="about-story-section">
          <div className="about-story-inner container">
            <div className="about-story-copy about-story-copy-left">
              <p>
                That is exactly why Myprega was born. We didn't just want to build another clinic; we wanted to
                spark a revolution in how women are treated. We believed that no mother should have to wait a
                whole month just to know if her baby is safe. By uniting a cohesive team of 9 elite medical
                experts with a proactive & holistic approach, tech-driven daily tracking, early detection of
                complications, and diagnostics, we built India’s first end-to-end tech-driven pregnancy
                ecosystem. We exist to replace your anxiety with absolute clinical certainty and holistic
                emotional support. Our promise is simple: we handle the science, the scheduling, and the
                safety, so you can finally experience the stress-free, celebratory journey you truly deserve.
              </p>
            </div>

            <div className="about-story-figure-wrap">
              <img src="/aboutC25445.png" alt="" className="about-story-cloud about-story-cloud-left-top" />
              <img src="/aboutC25445.png" alt="" className="about-story-cloud about-story-cloud-left-bottom" />
              <img src="/aboutH35454.png" alt="" className="about-story-figure" />
              <img src="/aboutC25445.png" alt="" className="about-story-cloud about-story-cloud-right" />
            </div>

            <div className="about-story-copy about-story-copy-right">
              <p>
               For too long, the world has focused entirely on the two days of delivery—celebrating the
              baby while completely overlooking the woman making the miracle happen. We believe
              the mother deserves to be the center of the story. Our deepest commitment is to turn
              every single day of your 270-day journey into a beautifully supported celebration, rather
              than a silent struggle.
              </p>
            </div>
          </div>
        </section>

        <section
          className="about-third-section"
          style={{
            backgroundImage: `url(${process.env.PUBLIC_URL}/aboutSB.png)`,
          }}
        >
          <div className="about-third-inner container">
            <div className="about-third-copy">
              <p className="about-third-highlight">
                Looking for the perfect pregnancy care package? Look no further
                than myprega!
              </p>
              <p className="about-third-description">
                Ready to elevate your pregnancy experience? Dive into the world
                of myprega difference and discover how we&apos;re redefining
                antenatal care for expecting moms everywhere using technology!
                From personalized support to medical expert guidance, we&apos;ve
                got everything covered in one affordable tech-driven package. We
                are your ultimate partner for a healthy and stress-free
                pregnancy. Elevate Your Pregnancy Journey with myprega&apos;s
                all-in-one comprehensive tech-driven 9-months pregnancy care
                package.
              </p>
            </div>

            <div className="about-third-mission">
              <h2>
                Our <span>Mission</span>
              </h2>
              <p>
                To pioneer the ultimate standard of proactive maternal care.
              </p>
            </div>

            <div className="about-third-vision">
              <h2>Our <span>Vision</span></h2>
              <p>
                To fundamentally elevate how the world experiences motherhood.
              </p>
            </div>
          </div>
        </section>
      </div>
      <Footer />
      <InteraktScript />
    </div>
  );
}

export default About;
